<div id="wrapper" class="h-100vh" style="width: 100%; margin-left: 0px;">
  <!-- Content Wrapper -->
  <div style="width: 100%;" id="content-wrapper" class="d-flex flex-column ml-0">
    <!-- Main Content -->
    <div id="content">
      <div class="container-fluid">
        <div class="row logo">
          <div class="col-12 row no-gutters justify-content-center">
            <h1
              class="d-flex justify-content-center"
              style="flex-direction: column; align-items: center"
            >
              <img [src]="baseUri + '/assets/doctors-next/Logo.png'" alt="Doctors Next" />
            </h1>
          </div>
        </div>

        <div class="row" style="letter-spacing: 0">
          <form
            (submit)="submitChangePassword()"
            class="col-12 user-form-reset mx-auto center-block mt-5"
          >
            <div
              *ngIf="errors.length > 0"
              class="row no-gutters mx-auto error-message"
            >
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">
                  <ul class="m-0">
                    <li *ngFor="let error of errors">{{ error }}</li>
                    <!-- @foreach($errors->all() as $error)
                    <li>{{ $error }}</li>
                    @endforeach -->
                  </ul>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="input-group justify-content-center">
                <label
                  class="col-form-label text-dark mb-0 py-0"
                  for="password"
                  style="font-size: 16px !important"
                  >新しいパスワードを入力</label
                >
              </div>
              <div class="input-group justify-content-center">
                <input
                  type="password"
                  class="form-control"
                  id="password"
                  name="password"
                  placeholder="パスワード"
                  [(ngModel)]="password"
                  autofocus=""
                  aria-describedby="password-help"
                />
              </div>
              <div class="input-group justify-content-center">
                <span
                  class="text-gray-500 password-note"
                  style="color: #999999 !important"
                  >パスワードは大・小文字含む8文字以上で入力してください。</span
                >
              </div>
            </div>

            <div class="form-group">
              <div class="input-group justify-content-center">
                <label
                  for="password_confirmation"
                  class="col-form-label text-dark mb-0 py-0"
                  style="font-size: 16px !important"
                  >新しいパスワード（再入力）</label
                >
              </div>
              <div class="input-group justify-content-center">
                <input
                  type="password"
                  class="form-control"
                  id="password_confirmation"
                  placeholder="パスワード"
                  name="password_confirmation"
                  [(ngModel)]="confirmationPassword"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-12 text-center">
                <button type="submit" class="btn px-3 mb-2">
                  パスワードを変更する</button
                ><br />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
